// AppLayout.js
import React, { useState } from 'react';
import { Box, Typography, IconButton, useTheme } from '@mui/material';
import { Menu as MenuIcon, ChevronLeft, ChevronRight } from '@mui/icons-material';
import Sidebar from './Sidebar';
import MainContent from './MainContent';

const AppLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const theme = useTheme();

  // Ancho del sidebar (debe coincidir con el ancho real de tu Sidebar)
  const sidebarWidth = 280; // Ajusta este valor según el ancho de tu Sidebar

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar con botón de toggle integrado */}
      <Box sx={{ position: 'relative' }}>
        <Sidebar isOpen={sidebarOpen} toggle={toggleSidebar} />
        
        {/* Botón de toggle - Ahora con position: 'fixed' */}
        <IconButton
          onClick={toggleSidebar}
          sx={{
            position: 'fixed',
            top: { xs: 8, md: 12 },
            left: {
              xs: sidebarOpen ? sidebarWidth - 60 : 8,
              md: sidebarOpen ? sidebarWidth - 60 : 70
            },
            zIndex: 1200,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid',
            borderColor: theme.palette.primary.main,
            width: { xs: 28, md: 32 },
            height: { xs: 28, md: 32 },
            '&:hover': {
              backgroundColor: theme.palette.primary.main,
              '& .MuiSvgIcon-root': {
                color: 'white'
              }
            },
            boxShadow: theme.shadows[4],
            transition: 'all 0.3s ease'
          }}
        >
          {sidebarOpen ? (
            <ChevronLeft sx={{ color: theme.palette.primary.main, fontSize: { xs: 16, md: 20 } }} />
          ) : (
            <ChevronRight sx={{ color: theme.palette.primary.main, fontSize: { xs: 16, md: 20 } }} />
          )}
        </IconButton>
      </Box>

      {/* Contenedor principal */}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          maxWidth: '100%',
          transition: 'all 0.3s ease',
          backgroundColor: theme.palette.background.default,
        }}
      >
        {/* Barra superior para móviles */}
        <Box
          sx={{
            display: { xs: 'flex', md: 'none' },
            alignItems: 'center',
            px: { xs: 1, sm: 2 },
            py: { xs: 0.5, sm: 1 },
            backgroundColor: theme.palette.background.paper,
            borderBottom: '1px solid',
            borderColor: 'divider',
            position: 'sticky',
            top: 0,
            zIndex: 1100,
          }}
        >
          <IconButton onClick={toggleSidebar} size="small">
            <MenuIcon />
          </IconButton>
          <Typography 
            variant="h6" 
            sx={{ 
              ml: 1, 
              fontWeight: 700,
              fontSize: { xs: '1rem', sm: '1.1rem' },
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            EPCore
          </Typography>
        </Box>

        {/* Contenido principal */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 1, sm: 2, md: 3 },
            backgroundColor: theme.palette.background.default,
            overflow: 'auto',
            width: '100%',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <MainContent />
        </Box>

        {/* Footer */}
        <Box
          component="footer"
          sx={{
            py: { xs: 1, sm: 1.5 },
            px: { xs: 1, sm: 2, md: 3 },
            textAlign: 'center',
            borderTop: '1px solid',
            borderColor: 'divider',
            backgroundColor: theme.palette.background.paper,
            flexShrink: 0,
          }}
        >
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}>
            © {new Date().getFullYear()} EPCore - Todos los derechos reservados
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AppLayout;